export const UPPERCASE_MAKES_AND_MODLES = [
  "AC",
  "AK",
  "BAC",
  "BMW",
  "BYD",
  "CUPRA",
  "DS AUTOMOBILES",
  "GMC",
  "GWM ORA",
  "INEOS",
  "ISO",
  "JAECOO",
  "KGM",
  "KTM",
  "LEVC",
  "MAXUS",
  "MG",
  "MINI",
  "MK",
  "MOKE",
  "NG",
  "PGO",
  "RAM",
  "RCR",
  "TD",
  "TVR",
  "VW",
  "GLA",
  "GLB",
  "GLC",
  "GLE",
  "GLS",
];
